export default "__VITE_ASSET__30903a65__"